import { Tooltip } from '@mantine/core';
import { User } from 'lucide-react';
import { FC, useMemo } from 'react';

import NullComponent from '@/components/NullComponent.tsx';

import useAuth from '@/hooks/useAuth.ts';

import { UserGroup } from '@/models/User.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    isRegistered: boolean;
}

const PatientTypeIndicator: FC<Props> = ({ isRegistered }) => {
    const { isUserInGroup, auth_user } = useAuth();

    const is_rendered = useMemo(() => {
        return isUserInGroup([
            UserGroup.DEV_INTERNAL_ENGINEERS,
            UserGroup.PROD_INTERNAL_ENGINEERS,
            UserGroup.INTERNAL_PRODUCT_MANAGER,
            UserGroup.DEV_INTERNAL_QA,
            UserGroup.PROD_INTERNAL_QA,
        ]);
    }, [auth_user]);

    if (!is_rendered) {
        return <NullComponent />;
    }

    return (
        <Tooltip label={isRegistered ? 'Registriert' : 'Nicht registriert'}>
            <User className={cn('size-4', isRegistered ? 'text-green-700' : 'text-red-700')} />
        </Tooltip>
    );
};

export default PatientTypeIndicator;
